import React, { useEffect, useState, useContext } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  FormGroup,
  Label,
  Form,
  Input,
  FormFeedback,
  Row,
} from "reactstrap";
import Select from "react-select";
import {
  resourcesUnits,
  adminUsers,
  resourcesRoutes,
} from "../../../helpers/backend_helper";
import { getStorageUser, getStorageCompany } from "../../../helpers/api_helper";
import { Alert } from "../../../helpers/alerts/alertHelper";
import Validate from "./Validate";
import { useFormik } from "formik";
import * as Yup from "yup";
import classNames from "classnames";
import NibbleInput from "../../../components/Fields/NibbleInput";

const TYPES = [
  { id: "Camión"},
  { id: "Combi"},
  { id: "Microbus"},
  { id: "Autobus"},
  { id: "Otro"},
];

const YESNO = [
  { label: "Si", id: true },
  { label: "No", id: false },
]

const FUEL_TYPES = [
  {id:'Gas'},
  {id:'Gasolina'},
  {id:'Diesel'}
];

const AddUpdModal = ({modal,setModal,items, setItems, setItem,item}) => {
	const [ routes, setRoutes ] = useState([]);
	const [ users, setUsers ] = useState([]);
	const [ loading, setLoading ] = useState(false);
	const [ newConcessionary,setNewConcessionary ] = useState(false);
	const authUser = getStorageUser();

  const validation = useFormik({
		enableReinitialize: true,
		initialValues: {...item},
		validationSchema: Yup.object({
			number: Yup.number().nullable(true).required('Requerido'),
			route_id: Yup.number().nullable(true).required('Requerido'),
      concessionary_id: Yup.number().nullable(true).required('Requerido'),
		}),
		onSubmit: async values => {
			await save(values)
			
		},
	});

  useEffect(() => {
    adminUsers().then(response => {
        setUsers(response.users)
    })
    if(authUser.profile_id!=3){
      resourcesRoutes('get',{}).then(response => {
        setRoutes(response.data)
      })
    }
  }, [])

  const company = getStorageCompany();


  useEffect(() => {
    adminUsers().then((response) => {
      setUsers(response.users);
    });
    if (authUser.profile_id != 3) {
      resourcesRoutes("get", {}).then((response) => {
        setRoutes(response.data);
      });
    }
  }, []);

	const handleClose = () => {
		setModal({...modal,show:false,update:false});
  }

  const save = async (data) => {
    try {
      setLoading(true)
      const response = modal.update ? await resourcesUnits('put',data,data.id):await resourcesUnits('post',data)
      responseAction(response)
      setLoading(false);
    } catch (err) {
      console.error(err)
      setLoading(false)
    }
  };

  const responseAction = (response) => {
    if (response.status) {
      const newItem = response.unit;
      let array = [];
      if (modal.update) {
        array = items.map((item) => (item.id !== newItem.id ? item : newItem));
      } else {
        array = [...items, newItem];
        array.sort((a, b) => {
          return a.id - b.id;
        });
      }
      setItems(array);
      handleClose();
    } else {
      setErrors(response.response.data.errors);
    }
  };

  return (
    <div>
      <Modal isOpen={modal.show} className="modal-dialog modal-lg">
        <ModalHeader className="bg-primary">
          {modal.update ? "Editar Unidad" : "Nueva Unidad"}
        </ModalHeader>
        <Form
          onSubmit={e => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <ModalBody>

            <Row>
              <NibbleInput
                md={4}
                label="Unidad:"
                fieldName="number"
                fieldType="text"
                validation={validation}
              />

              {authUser.profile_id == 2 && (
                <NibbleInput
                  md={8}
                  label="Ruta:"
                  fieldName="ruta"
                  fieldType="select"
                  selectItems={routes ?? []}
                  validation={validation}
                  selectOptionLabel={ (option) => `${option.number}` }
                />
              )}
              <NibbleInput
                md={4}
                label="Tipo:"
                fieldName="type"
                fieldType="select"
                selectItems={TYPES ?? []}
                validation={validation}
                selectOptionLabel={ (option) => `${option.id}` }
                selectOptionValue={ (option) => option.id }
              />
              
              <NibbleInput
                md={4}
                label="Envio automático:"
                fieldName="automatic"
                fieldType="select"
                selectItems={YESNO ?? []}
                validation={validation}
                selectOptionLabel={ (option) => `${option.label}` }
                selectOptionValue={ (option) => option.id }
              />

              <NibbleInput
                md={4}
                label="VIN:"
                fieldName="vin"
                fieldType="text"
                validation={validation}
              />

              <NibbleInput
                md={4}
                label="No de motor:"
                fieldName="no_motor"
                fieldType="text"
                validation={validation}
              />

              <NibbleInput
                md={4}
                label="Placas:"
                fieldName="plates"
                fieldType="text"
                validation={validation}
              />

              <NibbleInput
                md={4}
                label="Año:"
                fieldName="model"
                fieldType="number"
                validation={validation}
              />

              <NibbleInput
                md={4}
                label="Marca:"
                fieldName="brand"
                fieldType="text"
                validation={validation}
              />

              <NibbleInput
                md={4}
                label="Revista Mecánica:"
                fieldName="mechanic_meg"
                fieldType="text"
                validation={validation}
              />
              
              <NibbleInput
                md={4}
                label="Contador:"
                fieldName="counter"
                fieldType="select"
                selectItems={YESNO ?? []}
                validation={validation}
                selectOptionLabel={ (option) => `${option.label}` }
                selectOptionValue={ (option) => option.id }
              />

              <NibbleInput
                md={4}
                label="Tipo de combustible:"
                fieldName="fuel_type"
                fieldType="select"
                selectItems={FUEL_TYPES ?? []}
                validation={validation}
                selectOptionLabel={ (option) => `${option.id}` }
                selectOptionValue={ (option) => option.id }
              />

              <NibbleInput
                md={4}
                label="Concesionario:"
                fieldName="concessionary_id"
                fieldType="select"
                selectItems={users ?? []}
                selectOptionLabel={ (option) => `${option.full_name}` }
                validation={validation}
              />
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" type="
            " disabled={loading}>
              {loading && <Spinner size="sm"></Spinner>} <i className="fa fa-save"></i> Guardar
            </Button>{" "}
            <Button color="secondary" onClick={handleClose}>
              <i className="fa fa-times"></i> Cancelar
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default AddUpdModal;
